"use client"

import MediaModal from "@/(admin)/components/image/media-modal"
import AddNewMedia from "@/(admin)/modules/media/pages/AddNewMedia"
import { ADMIN_API_CONFIG } from "@/constants/api-configs"
import { Images } from "@/constants/images"
import { t } from "@/languages/i18n"
import { cn } from "@/lib/utils"
import { DeleteOutlined, PlusOutlined } from "@ant-design/icons"
import { Button, Image, Modal } from "antd"
import React, { useState } from "react"
import { MediaData } from "../../../lib/config/types"

interface ImageModalProps {
  selectedMedia?: MediaData[]
  setSelectedMedia: (media: MediaData[]) => void
  selectMode: "single" | "multi"
  className?: string
}

const ImageModal: React.FC<ImageModalProps> = ({ selectedMedia, setSelectedMedia, selectMode, className }) => {
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [isChooseMedia, setIsChooseMedia] = useState(true)

  const handleOpenModal = () => {
    setIsModalOpen(true)
  }

  const handleCloseModal = () => {
    setIsModalOpen(false)
  }

  const handleSelectMedia = (media: MediaData | MediaData[]) => {
    if (Array.isArray(media)) {
      setSelectedMedia([...(selectedMedia || []), ...media])
    } else {
      setSelectedMedia([media])
    }
    setIsModalOpen(false)
  }

  const handleRemoveImage = (index: number) => {
    const updatedMedia = (selectedMedia || []).filter((_, i) => i !== index)
    setSelectedMedia(updatedMedia)
  }

  const BoxAddImage = () => {
    return (
      <div
        className="w-[150px] h-[150px] border text-[#1677ff] border-blue-400 rounded-lg flex items-center justify-center cursor-pointer flex-col gap-2"
        onClick={handleOpenModal}
      >
        <PlusOutlined className="text-2xl" />
        <div className="text-sm">Thêm ảnh</div>
      </div>
    )
  }
  return (
    <div
      className={cn("border border-gray-300 rounded-[10px] mb-5", selectMode === "single" ? "w-fit" : "", className)}
    >
      <div className="m-4">
        {!selectedMedia || selectedMedia.length === 0 ? (
          <div className={cn("flex gap-4", selectMode === "single" ? "flex-col" : "flex-row")}>
            {selectMode === "multi" ? (
              <BoxAddImage />
            ) : (
              <>
                <Image
                  src={Images.imgEmpty.src}
                  alt="featured"
                  className="w-full cursor-pointer"
                  preview={false}
                  onClick={handleOpenModal}
                  width={150}
                  height={150}
                />
                <Button variant="outlined" color="primary" icon={<PlusOutlined />} onClick={handleOpenModal}>
                  {t("Add Image")}
                </Button>
              </>
            )}
          </div>
        ) : (
          <div className={cn("flex flex-row gap-4 flex-wrap", selectMode === "single" ? "flex-col" : "")}>
            {selectedMedia.map((media, index) => (
              <div
                key={index}
                className="relative w-[150px] h-[150px] border border-gray-200 rounded-lg hover:scale-105 transition-all duration-300 overflow-hidden"
              >
                <Image
                  src={
                    media?.attributes === undefined
                      ? `${ADMIN_API_CONFIG.API_URL}${media?.url}`
                      : `${ADMIN_API_CONFIG.API_URL}${media.attributes?.url}`
                  }
                  alt="featured"
                  className="shadow-lg rounded-lg cursor-pointer object-cover !h-[150px] !w-[150px]"
                />
                <div
                  className="absolute top-1 right-1 h-8 w-8 flex items-center justify-center cursor-pointer bg-red-500 rounded-lg border-white border hover:scale-110 transition-all duration-300"
                  onClick={() => handleRemoveImage(index)}
                >
                  <DeleteOutlined className="text-white" />
                </div>
              </div>
            ))}

            {selectMode === "multi" ? (
              <BoxAddImage />
            ) : (
              <Button variant="outlined" color="primary" onClick={handleOpenModal}>
                {t("Change Image")}
              </Button>
            )}
          </div>
        )}
      </div>

      <Modal
        open={isModalOpen}
        onCancel={handleCloseModal}
        style={{ top: 20 }}
        width="95%"
        footer={null}
        styles={{ body: { padding: "20px" } }}
      >
        <div className="">
          <Button
            onClick={() => setIsChooseMedia(true)}
            className="mr-2"
            style={{ backgroundColor: isChooseMedia ? "blue" : "initial", color: isChooseMedia ? "white" : "initial" }}
          >
            {t("Select Media")}
          </Button>
          <Button
            onClick={() => setIsChooseMedia(false)}
            style={{
              backgroundColor: !isChooseMedia ? "blue" : "initial",
              color: !isChooseMedia ? "white" : "initial",
            }}
          >
            {t("Upload Media")}
          </Button>
        </div>
        <div className="-ml-4">
          {isChooseMedia ? (
            <MediaModal isOpenModal={true} onSelectMedia={handleSelectMedia} selectMode={selectMode} />
          ) : (
            <AddNewMedia isOpenModal={true} setChooseMedia={setIsChooseMedia} />
          )}
        </div>
      </Modal>
    </div>
  )
}

export default ImageModal
